import view from 'redux/view/actions'
import misc from 'redux/misc/actions'
import models from 'redux/models/actions'


export default {
  view,
  misc,
  models,
}
